import React, { useEffect, useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import UserContext from '../../config/UserContext'
import {
  HttpService,
  API,
  swal,
  Title,
  toast,
  Messages,
  DateFormat,
  Spinner
} from '../../config/react'
import DataTable from 'react-data-table-component'

const Categories = () => {
  const [CategoryList, setCategoryList] = useState([])
  const user = useContext(UserContext)
  const [IsAuth, setIsAuth] = useState(false)
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [loading, setLoading] = useState(true)
  const [SearchTerm, setSearchTerm] = useState('')

  const DefaultFilters = {
    page: 1,
    // search: 'rdfg',
    page_size: 10,
    sort_column: '',
    sort_direction: ''
  }
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)
  const [totalRows, settotalRows] = useState()

  const columns = [
    // {
    //   name: 'Image',
    //   selector: (row) => (
    //     <img
    //       src={row.image}
    //       width="100"
    //       onError={(e) => {
    //         e.target.onerror = null
    //         e.target.src = row.altimage
    //       }}
    //     />
    //   )
    // },
    {
      name: 'Name',
      sortable: true,
      sortField: 'name',
      wrap: true,
      selector: (row) => row.name
    },
    {
      name: 'Slug',
      selector: (row) => row.slug,
      wrap: true
    },
    {
      name: 'Parent Category',
      selector: (row) => (row.parent_id !== 1 ? row.parent_category : '-'),
      wrap: true
    },
    {
      name: 'Created Date',
      sortable: true,
      sortField: 'created_at',
      selector: (row) => <DateFormat value={row.created_at}></DateFormat>,
      wrap: true
    },
    {
      name: 'Status',
      selector: (row) => (row.status === 1 ? <label>Active</label> : <label>Inactive</label>)
    },
    {
      name: 'Action',
      selector: (row) => (
        <div className="action-btn">
          <Link
            to={'/categories/edit/' + row.id}
            className="text-dark"
            title="Edit"
          >
            <i
              className="fa fa-pencil-square-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
          <Link
            onClick={(e) => DeleteCategory(e, row.id)}
            to=""
            className="text-dark"
            title="Delete"
          >
            <i
              className="fa fa-trash-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
        </div>
      )
    }
  ]

  const GetCategoryList = () => {
    const categoryData = {
      page: CustomFilters.page,
      search: SearchTerm,
      page_size: CustomFilters.page_size,
      sort_column: CustomFilters.sort_column,
      sort_direction: CustomFilters.sort_direction
    }
    // console.log('LN 80 Page '+CustomFilters.page+' &page_size '+CustomFilters.page_size);
    setLoading(true)
    // HttpService.postApi(API.GetCategory,null)
    HttpService.postApi(API.GetCategoryAdminList, categoryData).then((response) => {
      setLoading(false)
      if (response.data.status === true) {
        const data = response.data.result[0]
        setCategoryList(data)
        settotalRows(response.data?.result[0][0].total_category)
        setForceUpdate(!isForceUpdate)
      }
    })
  }

  useEffect(() => {
    setIsAuth(true)
    document.title = Title.Category
    GetCategoryList()
    setForceUpdate(!isForceUpdate)
  }, [CustomFilters, SearchTerm])

  const handlePageChange = (e) => {
    setCurrentPage(e)
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCurrentPage(1)
    setCustomFilters({ ...CustomFilters, page: 1, page_size: e })
  }
  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <input
        type="text"
        title="Search For Name, Slug, Parent Category."
        className="form-control col-md-3"
        placeholder="Search"
        // value={CustomFilters.search}
        onChange={(e) =>
          setTimeout(() => {
            setSearchTerm(e.target.value)
          }, 1000)
        }
      />
    )
  })

  const DeleteCategory = async (e, id) => {
    e.preventDefault()
    swal(Messages.SwalDeleteProp).then(function (isConfirm) {
      if (isConfirm) {
        const param = {
          id,
          IsDeleted: true,
          deleted_by: user.id
        }
        setLoading(true)
        HttpService.postApi(API.DeleteCategory, param).then((response) => {
          setLoading(false)
          toast.success(Messages.RecordDeleted)
          GetCategoryList()
          setForceUpdate(!isForceUpdate)
        })
      }
    })
  }

  const handleSort = (e, direction) => {
    setCustomFilters({
      ...CustomFilters,
      sort_column: e.sortField,
      sort_direction: direction
    })
  }

  return !IsAuth ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.Category} </h3>
        <div className="btn-group">
          <Link
            to="/categories/add"
            className="btn btn-dark btn-fw rounded mr-2"
          >
            {' '}
            Add Category{' '}
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={CategoryList}
                  // progressPending={loading}
                  pagination
                  paginationServer
                  persistTableHead={true}
                  progressPending={loading}
                  progressComponent={<Spinner />}
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  paginationDefaultPage={currentPage}
                  subHeader
                  subHeaderComponent={subHeaderComponentMemo}
                  onSort={handleSort}
                  sortServer
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Categories
